
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "25px",
    },
    width: {
      type: String,
      default: "70px",
    },
    to: {
      type: String,
      default: "/",
    },
  },
  emits: {
    "logo-click": () => true,
  },
});
